module.exports = __webpack_public_path__ + "static/img/__4839.8771037.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__4839.jpg
// module id = pkYz
// module chunks = 0